module.exports = {
	"classes": [
		"wordpress-page",
		"header-dark"
	],
	"title": "WordPress Authentication",
	"metas": {
		"description": "Advanced Identity Management in WordPress can be very hard. At Auth0 we want to change that, by simplifying as much as possible."
	},
	"opengraph": {
		"og:title": "WordPress Authentication",
		"og:description": "Advanced Identity Management in WordPress can be very hard. At Auth0 we want to change that, by simplifying as much as possible.",
		"og:url": "https://auth0.com/wordpress",
		"og:image": "https://cdn.auth0.com/website/assets/pages/wordpress/img/twitter-card-1cc65617d8.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/wordpress/img/twitter-card-1cc65617d8.png"
	},
	"twittercard": {
		"twitter:title": "Passwordless: SMS Login and Email Authentication",
		"twitter:description": "Advanced Identity Management in WordPress can be very hard. At Auth0 we want to change that, by simplifying as much as possible.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/wordpress/img/twitter-card-1cc65617d8.png",
				"width": "2400",
				"height": "1600"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/wordpress/data/metadata.json
// module id = 1148
// module chunks = 0